var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5h16c.55228 0 1 .44772 1 1s-.44772 1-1 1H4c-.55228 0-1-.44772-1-1s.44772-1 1-1zm0 4h16c.55228 0 1 .44772 1 1s-.44772 1-1 1H4c-.55228 0-1-.44772-1-1s.44772-1 1-1zm0 4h16c.55228 0 1 .44772 1 1s-.44772 1-1 1H4c-.55228 0-1-.44772-1-1s.44772-1 1-1zm0 4h16c.55228 0 1 .44772 1 1s-.44772 1-1 1H4c-.55228 0-1-.44772-1-1s.44772-1 1-1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListMode);
export default __webpack_public_path__ + "static/media/listMode.f3ab5b6f.svg";
export { ForwardRef as ReactComponent };